/* Wowtel motion: Apple-style scroll reveal + top progress bar.
   Recreated from the design handoff. Reveals once, staggers grid
   children ~85ms, respects prefers-reduced-motion. Design-time
   polish — intentionally not exposed as customer-facing settings. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupReveal() {
    if (reduce) return;
    var scopes = document.querySelectorAll('.wt-scope');
    var targets = [];

    scopes.forEach(function (scope) {
      // Each top-level section/footer's content "beats" reveal in sequence.
      scope.querySelectorAll('[data-wt-reveal-group]').forEach(function (group) {
        var kids = Array.prototype.filter.call(group.children, function (c) {
          return c.nodeType === 1;
        });
        kids.forEach(function (el, i) {
          el.classList.add('wt-reveal');
          el.style.transitionDelay = (i * 0.085) + 's, ' + (i * 0.085) + 's';
          targets.push(el);
        });
      });
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { io.observe(el); });
  }

  function setupProgress() {
    var bar = document.querySelector('.wt-progress__bar');
    if (!bar) return;
    function update() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      var pct = Math.min(1, Math.max(0, (window.scrollY || h.scrollTop) / max));
      bar.style.width = (pct * 100).toFixed(2) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() { setupReveal(); setupProgress(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
